import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';
import { faDownLeftAndUpRightToCenter, faTimes, faUpRightAndDownLeftFromCenter } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import "swiper/css";
import { Keyboard } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import useDisableBodyScroll from '../../../hooks/useDisableBodyScroll';
import { useBreakpoint } from "../../../libs/breakpoint";
import createLink from "../../../libs/createLink";
import './AdvancedMediaViewer.scss';
import AdvancedMediaViewerItem from './components/AdvancedMediaViewerItem/AdvancedMediaViewerItem';

const AdvancedMediaViewer = ({medias = [], initialMediaId, handleClose=()=>{}, openFullScreen = false})=>{
    const breakpoints = useBreakpoint();
    const location = useLocation();
    const isMobile = breakpoints.xs || breakpoints.sm;
    const [fullscreen, setFullscreen] = useState(isMobile || openFullScreen);
    const initialMediaIndex = typeof initialMediaId === 'string' ? medias.findIndex(media => media._id === initialMediaId) : 0;
    const [toggleSlider, setToggleSlider] = useState(true);
    const [currentSwiperIndex, setCurrentSwiperIndex] = useState(0);
    const swiperRef = useRef(null);
    useDisableBodyScroll();

    useEffect(() => {
        const currentMedia = medias[initialMediaIndex];
        const linkHref = createLink(currentMedia.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {
            ...currentMedia.owner,
            media: {_id: currentMedia._id, slug: currentMedia.slug}
        });
        if(!window.location.pathname.includes(currentMedia._id)) window.history.pushState(null, "", linkHref);
        return () => {
            if(window.location.pathname.includes('/xxx-')) window.history.pushState(null, "", location.pathname);
        };
        // eslint-disable-next-line
    }, []);


    function handleSwiperIndex(currentIndex = 0){
        setCurrentSwiperIndex(currentIndex);
        const currentMedia = medias[currentIndex];
        if(currentMedia &&  window.location.pathname.includes('/xxx-')){
            const linkHref = createLink(currentMedia.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {
                ...currentMedia.owner,
                media: {_id: currentMedia._id, slug: currentMedia.slug}
            });
            window.history.replaceState(null, "", linkHref);
            if (window.plausible) {
                window.plausible('pageview');
            }
        }
    }

    const goNext = () => {
        if (swiperRef.current) {
          swiperRef.current.slideNext();
        }
      };
    
    const goPrev = () => {
        if (swiperRef.current) {
            swiperRef.current.slidePrev();
        }
    };

    return ReactDOM.createPortal(
        <div id='amv' className={classNames({fullscreen : fullscreen ||  isMobile})}>
            <Helmet>
                <meta name="theme-color" content="#000"/>
            </Helmet>
            {(!isMobile && !fullscreen) && (<div id="amv-close" onClick={handleClose}/>)}
            {(!isMobile && medias.length > 1) && (
                <div id="amv-slides-nav" className={classNames({fullscreen})}>
                   {currentSwiperIndex > 0 && (
                       <div className="amv-slide-nav-btn" onClick={goPrev}>
                           <FontAwesomeIcon icon={faAngleUp}/>
                       </div>
                     )}
                    {currentSwiperIndex < medias.length - 1 && (
                        <div className="amv-slide-nav-btn" onClick={goNext}>
                            <FontAwesomeIcon icon={faAngleDown}/>
                        </div>
                    )}
                </div>
            )}
            <div id="amv-container">
                <div className="amv-nav-wrapper">
                    <div className='amv-nav-group'>
                        {!isMobile && (
                            <div className="amv-nav-button" onClick={()=>setFullscreen(!fullscreen)}>
                            <FontAwesomeIcon icon={fullscreen ? faDownLeftAndUpRightToCenter : faUpRightAndDownLeftFromCenter}/>
                        </div>
                        )}
                        
                    </div>
                    <div className="amv-nav-button" onClick={handleClose}>
                        <FontAwesomeIcon icon={faTimes}/>
                    </div>
                </div>
                <Swiper 
                    direction={'vertical'}
                    loop={false}
                    className="amv-scroll-container"
                    modules={[Keyboard]}
                    initialSlide={initialMediaIndex}
                    allowSlideNext={toggleSlider}
                    allowSlidePrev={toggleSlider}
                    slidesPerView={1}
                    keyboard={{
                        enabled: true,
                      }}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    onActiveIndexChange={(swiper) => handleSwiperIndex(swiper?.activeIndex || 0)}
                    onKeyPress={(swiper, keyCode) => {
                        switch (keyCode) {
                            case 37:
                                swiper.slidePrev();
                              break;
                            case 39:
                                swiper.slideNext();
                              break;
                            default:
                        }
                    }}
                >
                    {medias.map((media, index)=>( <SwiperSlide key={media._id} virtualIndex={media._id} >
                        <AdvancedMediaViewerItem 
                            media={media} 
                            handleClose={handleClose} 
                            toggleSlider={toggleSlider} 
                            setToggleSlider={setToggleSlider} 
                            coverMode={fullscreen && isMobile} 
                            />
                    </SwiperSlide>))}
                </Swiper>
            </div>
        </div>,
        document.body);
}

export default React.memo(AdvancedMediaViewer, (prevProps, nextProps) => {
    return prevProps?.medias?.length === nextProps?.medias?.length &&
           prevProps?.initialMediaId === nextProps?.initialMediaId
});